<template>
  <!--<div>-->

  <div class="bar van-hairline--top">
    <div class="item">
      <span @click="likeArticle">
        <i class="iconfont icon-xin" :class="{active: isLiked}"></i> 赞 · {{ article.like }}
      </span>
    </div>
    <div class="item van-hairline--left van-hairline--right">
      <span @click="commentArticle">
        <i class="iconfont icon-pinglun"></i> 评论 · {{ article.comment }}
      </span>
    </div>
    <div class="item">
      <span @click="collectArticle">
        <i class="iconfont icon-shoucang" :class="{active: isCollected}"></i> 收藏 · {{ article.favorite }}
      </span>
    </div>

  </div>
</template>

<script>
  import { likeArticle, unlikeArticle, collectArticle, uncollectArticle } from '@/api/common'

  export default {
    name: "article-bar",
    props: {
      article: Object
    },
    data() {
      return {
        comment: '',
        isCommentBoxShow: false,
      }
    },
    computed: {
      isLiked() {
        return this.article.likeUserIds && this.article.likeUserIds.indexOf(this.$store.state.userInfo.userId) > -1;
      },
      isCollected() {
        let favorite = false;
        this.$store.state.userInfo.favorite.forEach(item => {
          if (this.article.id === item.documentId) {
            favorite = true;
            return true;
          }
        });

        return favorite;
      }
    },
    methods: {
      async likeArticle() {
        if(!this.isLiked) {
          await likeArticle(this.article.id)

          this.article.like += 1
          this.article.likeUserIds.push(this.$store.state.userInfo.userId)
          this.$toast.success("谢谢你的赞")
        } else {
          await unlikeArticle(this.article.id)

          this.article.like = this.article.like > 0 ? this.article.like - 1 : 0
          let index = this.article.likeUserIds.indexOf(this.$store.state.userInfo.userId)
          this.article.likeUserIds.splice(index, 1)

          this.$toast("已经收回赞")
        }
      },
      async collectArticle() {
        if (!this.isCollected) {
          let favorite = {
            documentId: this.article.id,
            name: this.article.name,
            thumbnail: this.article.thumbnail
          };
          await collectArticle(favorite);

          this.article.favorite += 1;
          this.$toast('已收藏');

          this.$store.commit('USER_INFO', {
            favorite: [
              favorite,
              ...this.$store.state.userInfo.favorite
            ]
          });
        } else {
          await uncollectArticle(this.article.id)

          this.article.favorite = this.article.favorite > 0 ? this.article.favorite - 1 : 0
          this.$toast("已取消收藏")

          let favorite= [...this.$store.state.userInfo.favorite];
          favorite.forEach((item, index) => {
            if (this.article.id === item.documentId) {
              favorite.splice(index, 1);
              return true;
            }
          });
          this.$store.commit('USER_INFO', {favorite});
        }
      },
      commentArticle() {
        this.$emit('comment', 0)
      },
    }
  }
</script>

<style lang="less" scoped>
.bar {
  display: flex;

  padding: 14px 0;
  background-color: #fff;

  .active{
    color: #bea473;
  }

  &::after {
    border-color: #e5e8e9;
  }

  .item {
    width: 30%;
    flex: 1;
    text-align: center;
    color: #3f4449;

    &[class*=van-hairline]::after {
      border-color: #aeb3b8;
    }
  }
}
</style>